/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PipelineCandidateResponse } from './pipelineCandidateResponse';
import type { StageResponse } from './stageResponse';

export interface PipelineListResponse {
  candidates: PipelineCandidateResponse[];
  stages: StageResponse[];
  total_count: number;
  page: number;
  per_page: number;
  next_cursor?: string | null;
}
